
        import { Mapper } from "../../../../base/utils/mapper";
import { RehabilitationPhysiotherapyResponseModel } from "../../../../domain/models/consult/rehabilitation-physiotherapy-response.model";
import { RehabilitationPhysiotherapyResponseEntity } from "../entities/rehabilitation-physiotherapy-response.entity";
        export class RehabilitationPhysiotherapyImplementationRepositoryMapper extends Mapper<RehabilitationPhysiotherapyResponseEntity, RehabilitationPhysiotherapyResponseModel>{
            mapFrom(param:  RehabilitationPhysiotherapyResponseEntity):  RehabilitationPhysiotherapyResponseModel { 
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors
                }; 
            }
            mapTo(param:  RehabilitationPhysiotherapyResponseModel):  RehabilitationPhysiotherapyResponseEntity {
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors 
                };
            }
        }